import {createSlice, nanoid, PayloadAction} from '@reduxjs/toolkit';
import { AerialViewState, SceneCameraState } from './camera-slice';
import { SettingsState } from './settings-slice';

export interface Bookmark {
  id: string;
  name: string;
  date: string;
  position: number[];
  visible: boolean;
  visibleAssets: [],
  settings: SettingsState;
  aerialState: AerialViewState;
  sceneState: SceneCameraState;
}

export const bookmarksSlice = createSlice({
  name: 'bookmarks',
  initialState: [] as Bookmark[],
  reducers: {
    addBookmark: {
      reducer: (state, action: PayloadAction<Bookmark>) => {
        state.push(action.payload);
      },
      prepare: (name, position, settings, visibleAssets, aerialState, sceneState) => {
        const bookmark = {
          id: nanoid(),
          date: new Date().toISOString(),
          visible: true,
          name,
          position,
          settings,
          visibleAssets,
          aerialState,
          sceneState
        };

        return {payload: bookmark};
      }
    },
    deleteBookmark: (state, action) => {
      return state.filter(bookmark => bookmark.id !== action.payload);
    },
    deleteBookmarks: (state) => {
      state.splice(0, state.length);
    },
    changeName: (state, action) => {
      const {bookmarkID, name} = action.payload;
      const bookmark = state.find(bookmark => bookmark.id === bookmarkID);
      if (!bookmark) return;

      bookmark.name = name;
    },
    toggleBookmarksVisibility: (state, action) => {
      const visible = action.payload;
      state.forEach(bookmark => {
        bookmark.visible = visible;
      });
    },
    toggleBookmarkVisibility: (state, action) => {
      const bookmarkID = action.payload;
      const bookmark = state.find(bookmark => bookmark.id === bookmarkID);
      if (!bookmark) return;

      bookmark.visible = !bookmark.visible;
    },
    updateBookmark: (state, action) => {
      const {bookmarkID, position, settings,
        visibleAssets, aerialState, sceneState} = action.payload;

      const bookmark = state.find(bookmark => bookmark.id === bookmarkID);
      if (!bookmark) return;

      bookmark.position = position;
      bookmark.settings = settings;
      bookmark.aerialState = aerialState;
      bookmark.sceneState = sceneState;
      bookmark.visibleAssets = visibleAssets;
      bookmark.date = new Date().toISOString();
    }
  }
});

export default bookmarksSlice.reducer;

export const {
  addBookmark,
  deleteBookmark,
  deleteBookmarks,
  changeName,
  updateBookmark,
  toggleBookmarksVisibility,
  toggleBookmarkVisibility
} = bookmarksSlice.actions;

export const selectAllBookmarks = state => state.bookmarks;
